import script from "./KUploaderCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./KUploaderCarousel.vue?vue&type=script&setup=true&lang=js"

import "./KUploaderCarousel.vue?vue&type=style&index=0&id=fe0b6a96&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe0b6a96"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
